export type TUiTemplate = "General" | "Monotone" | "Minpaku";

export interface TemplateConfiguration {
  templateKey?: string;
  templateConfiguration?: string;
  customDesignConfig?: string;
}

const applicationIdTemplateMap: Record<string, TUiTemplate> = {
  "08dcc024-e8ac-4fc3-81bd-b80fd82d7f83": "Minpaku",
};

const templateKeyMap: Record<string, TUiTemplate> = {
  general: "General",
  monotone: "Monotone",
  minpaku: "Minpaku",
};

export class UiTemplateModule {
  public readonly uiTemplate: TUiTemplate;
  public readonly templateConfiguration: TemplateConfiguration;

  public constructor(
    applicationId: string,
    templateConfig?: TemplateConfiguration
  ) {
    // プレビューモードまたはテンプレート設定が指定されている場合
    if (templateConfig?.templateKey) {
      this.uiTemplate = templateKeyMap[templateConfig.templateKey] || "General";
    } else {
      // 従来のアプリケーションID判定
      this.uiTemplate = applicationId
        ? applicationIdTemplateMap[applicationId] || "General"
        : "General";
    }

    this.templateConfiguration = templateConfig || {};
  }

  // 設定値をパースして取得するヘルパーメソッド
  public getTemplateSettings<T = any>(): T {
    try {
      return this.templateConfiguration.templateConfiguration
        ? JSON.parse(this.templateConfiguration.templateConfiguration)
        : {};
    } catch (error) {
      console.warn("Failed to parse template configuration:", error);
      return {} as T;
    }
  }

  public getCustomDesignConfig<T = any>(): T {
    try {
      return this.templateConfiguration.customDesignConfig
        ? JSON.parse(this.templateConfiguration.customDesignConfig)
        : {};
    } catch (error) {
      console.warn("Failed to parse custom design config:", error);
      return {} as T;
    }
  }
}
